module.exports = __webpack_public_path__ + "static/media/PAPI.85d4fe86.png";